/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
 
import type { User } from '../models/User';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Create a new user
     * @param requestBody
     * @returns any User created successfully
     * @throws ApiError
     */
    public static createUser(
        requestBody: User,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        user?: User;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get all users
     * @returns User Successfully retrieved users
     * @throws ApiError
     */
    public static getAllUsers(): CancelablePromise<Array<User>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get user details
     * @param id User ID
     * @returns User Successfully retrieved user
     * @throws ApiError
     */
    public static getUserById(
        id: string,
    ): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update user details
     * @param id User ID to update
     * @param requestBody
     * @returns any User updated successfully
     * @throws ApiError
     */
    public static updateUser(
        id: string,
        requestBody: User,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        user?: User;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a user
     * @param id User ID to delete
     * @returns void
     * @throws ApiError
     */
    public static deleteUser(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
}
